import { useEffect, useState, useRef, useLayoutEffect, useContext, useCallback } from 'react';
import { useLocation, useNavigate, useRoutes, useSearchParams } from 'react-router-dom';
import PCRouter from "./router/pcrouter.js";
import MobileRouter from "./router/mobilerouter.js";
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { CardClickContext, ModalClickContext, PermissionContext } from './utils/context.js';
import './App.css';
import { LoginPanel } from './components/LoginPanel/index.js';
import ReactGA from "react-ga4";
import CookieConsent from "react-cookie-consent";
import { isPrerenderUserAgent, useRequest, useNewUserPromotionCountdown, usePromotionsFetch } from './utils/hooks';
import { trackEvent } from './utils/trackEvent'
import MicroNode from './omnicraft'

import {
    cameraParamsAtom,
    chatImageURLAtom,
    guessChatStatusAtom,
    isFeedbackModalOpenAtom,
    isOpenImg3dGenerateAtom,
    logInfoAtom,
    meshProfileAtom,
    modalObjAtom,
    posterGenerateAtom,
    regenePrivateSetAtom,
    setGenerateAtom,
    showDownloadAtom,
    showLoginAtom,
    showProgressAtom,
    taskDetailAtom,
    taskInitAtom,
    userPermissionAtom,
    packInfoAtom,
    groupInfoAtom,
    showHistoryAtom,
    showCardsConAtom,
    showStorageWrapperAtom,
    iframeAtom,
    omniPreAtom,
    // qrCodeUrlAtom,
    // cardsTypeAtom,
    // genMeInfoAtom,
    showSubscribeAtom,
    isImgto3dAtom,
    subscriptionsInfoAtom,
    isSmallScreenAtom,
    showRegenerateAtom,
    rodinGenPipeline,
    // processedPrompt,
    rodinUploadedImages,
    isRodinGeneratingAtom,
    showReferralAtom,
    showApiDashboardAtom,
    subscriptionsPreInfoAtom,
    balanceAtom,
    currentNavAtom,
    rodinRenderAtom,
    meshEditorMicroAppAtom,
    subscriptionsUnlimitInfoAtom,
    subscriptionsEduStateAtom,
    isFirstScreenShowAtom,
    chatLangAtom,
} from './store/index.js';
import Nav from './components/Nav/index.tsx';
import {
    getTaskDetail,
    getUserInfo,
    initNet,
    getGroupList,
    queryGroupInfo,
    getGroupSettings,
    getEduState,
    // createQr,
    // getGenerateProgress,
    getSubscriptionStatus, rodinHistory,
    logout
} from './utils/net.js';
import { GlobalTips, useTips } from './common/GlobalTips/index.js';
import { Modal } from './components/widgets/Modal/index.js';
import {
    getBrowserInfo,
    fetchAndConvertToFiles,
    resetGenPipeline,
    fetchObjectToLocalURL,
    checkMobile, truncateWithEllipsis,
} from './utils/format.js';
import { useDebounce, useLocalStorage } from './utils/hooks.js';
import * as Sentry from "@sentry/react";
import { FeedbackModal } from "./components/widgets/Feedback/index.js";
import { StorageBox } from "./components/widgets/StorageBox/index.js";
import { setGlobalShowFeedBack, setGlobalShowLogin, setGlobalTip } from './utils/tipsService.js';
import { Iframe } from './components/widgets/Iframe/index.js'
import { DevPanel } from './components/DevPanel/index.js';
import { Subscribe } from './components/Subscribe/index.js';
import { Referral } from './components/Referral/index.js';
import { ApiDashboard } from './components/ApiDashboard/index.js';
import material from "./components/Board/RodinGenerateBoard/components/Material/index.js";
import { fetchSettings } from "./components/Board/RodinGenerateBoard/utils.js";
import { useTranslation } from "react-i18next";
import PermissionProvider from "./utils/permissionProvider.js";
import Restricted from "./utils/restricted.js";
import { getPermission } from "./utils/permission.js";
import i18n from "i18next";
import { ModalProvider } from './common/CommonModal/index.js';
import SEOContent from "./common/SEOContent";
import {
    DEFAULT_LANG,
    getSeoContent,
} from "./utils/seo/utils";
import {
    chatAvatarBrandInfo,
    defaultRodinModelKeywords,
    modelPagePresetDescription,
    rodinBrandInfo,
    seoContentMap
} from "./utils/seo/store"
import Header from './components/Header/index.js';
import HeaderMobile from './mobilecomponents/header/index.js'
import MicroMeshEditorNode from './common/MeshEditorJumper/mesheditor.js';
import { isAnnotatorOpenAtom, promotionsAtom } from './store/rodin.js';
import FirstScreenAnimation from './components/newRodin/components/FirstScreenAnimation/index.js';
import { seededRandom } from "three/src/math/MathUtils";
import { interfaceLangAtom } from "./store/appStore";
import { resources } from "./i18n";
import { ErrorPage } from "./components/ErrorPage";
import { UpgradeModal } from './components/Promotional/NewUserPromotion/upgradeModal.js';

if (process.env.REACT_APP_SIMPLIFIED_RODIN === "true") {
    console.info("GA Disabled")
} else {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID ? process.env.REACT_APP_GA_MEASUREMENT_ID : '000000');
}

const MainApp = () => {
    const [showLogin, setShowLogin] = useRecoilState(showLoginAtom);
    const [logInfo,] = useRecoilState(logInfoAtom);
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    // const isVIP = ['Creator', 'Business', 'Enterprise', 'Education'].includes(subscriptionsInfo.plan_level)
    const showCardsCon = useRecoilValue(showCardsConAtom);
    const showHistory = useRecoilValue(showHistoryAtom);
    const [showSubscribe, setShowSubscribe] = useRecoilState(showSubscribeAtom)
    const generate = useRecoilValue(setGenerateAtom);
    const showRegenerate = useRecoilValue(showRegenerateAtom);
    const setMeshProfile = useSetRecoilState(meshProfileAtom);
    const setGuessChatStatus = useSetRecoilState(guessChatStatusAtom);
    const setChatImageURL = useSetRecoilState(chatImageURLAtom);
    const setTaskDetail = useSetRecoilState(taskDetailAtom);
    const setShowDownload = useSetRecoilState(showDownloadAtom);
    const setPosterGenerate = useSetRecoilState(posterGenerateAtom);
    const setShowProgress = useSetRecoilState(showProgressAtom);
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const setTaskInit = useSetRecoilState(taskInitAtom);
    const setPackInfo = useSetRecoilState(packInfoAtom);
    const setCameraParams = useSetRecoilState(cameraParamsAtom);
    const setRegenePrivateSet = useSetRecoilState(regenePrivateSetAtom);
    const setIsSmallScreen = useSetRecoilState(isSmallScreenAtom);
    const [isOpenImg3dGenerate, setIsOpenImg3dGenerate] = useRecoilState(isOpenImg3dGenerateAtom);
    const location = useLocation();
    const setGlobalTips = useTips();
    const [, setOpenPre] = useRecoilState(omniPreAtom)
    const tip = useTips();
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useRecoilState(isFeedbackModalOpenAtom);
    const [showStorageWrapper, setShowStorageWrapper] = useRecoilState(showStorageWrapperAtom)
    const feedbackModalRef = useRef(null);
    const storageBoxRef = useRef(null);
    const iframe = useRecoilValue(iframeAtom)
    const [genPipeline, setGenPipeline] = useRecoilState(rodinGenPipeline);
    const setRodinUploadedImages = useSetRecoilState(rodinUploadedImages);
    const isRodinGenerating = useRecoilValue(isRodinGeneratingAtom);
    const showReferral = useRecoilValue(showReferralAtom);
    const showApiDashboard = useRecoilValue(showApiDashboardAtom);
    const { t } = useTranslation();
    const { isAllowedTo, isUnlimited, isYearly } = useContext(PermissionContext);
    const [interfaceLang, setInterfaceLang] = useRecoilState(interfaceLangAtom);
    const isMobile = checkMobile()
    const [currentModelMetaData, setCurrentModelMetaData] = useState()
    const [currentSEOContent, setCurrentSEOContent] = useState();
    const currentNav = useRecoilValue(currentNavAtom);
    const meshEditorMicroApp = useRecoilValue(meshEditorMicroAppAtom);
    const isAnnotatorOpen = useRecoilValue(isAnnotatorOpenAtom);
    const isFirstScreenShow = useRecoilValue(isFirstScreenShowAtom);
    const [searchParams] = useSearchParams()
    const Fallback = <ErrorPage />;
    const setPromotions = useSetRecoilState(promotionsAtom);
    const { timeLeft, startCountdown, resetCountdown } = useNewUserPromotionCountdown()
    const {
        handleSubscribePromotion,
        upgradeModal,
        handleClose,
        handleConfirmPlan,
        loading
    } = usePromotionsFetch();

    useEffect(() => {
        setGlobalTip(tip);
    }, [tip]);

    useEffect(() => {
        localStorage.setItem('CURRENT_ROLE', window._env_.REACT_APP_ROLE)
        localStorage.setItem('NODE_ENV', process.env.NODE_ENV)
        setIsSmallScreen(window.innerWidth < 1280)
        const versionLimitMap = new Map([
            ['Chrome', 105],
            ['Edge', 88],
            ['Safari', 15],
            ['Firefox', 89],
            ['Opera', 74],
        ]);
        const curVersion = getBrowserInfo();
        setGlobalShowLogin(setShowLogin)
        setGlobalShowFeedBack(setIsFeedbackModalOpen)
        if (
            curVersion.name !== 'Unknown'
            && versionLimitMap.get(curVersion.name) > curVersion.version
        ) {
            tip({
                type: 'primary',
                content: t('TIP_PRIMARY_APP_UPGRADE_BROWSER'),
            });
        }


    }, [])

    useEffect(() => {
        const forbidFlag = isUnlimited() || isYearly();
        if (logInfo?.user_uuid) {
            const stored = localStorage.getItem('newUserPromotionTimeLeft');
            if (stored) {
                const data = JSON.parse(stored);
                // 只有当前用户的促销时间数据存在时才执行
                if (data[logInfo.user_uuid]) {
                    if (!forbidFlag) {
                        resetCountdown()
                    } else {
                        setPromotions(prev => ({ ...prev, newUser: { ...prev.newUser, show: true } }));
                        setTimeout(() => {
                            startCountdown()
                        }, 0)
                    }
                }
            }
        }
    }, [logInfo])

    useEffect(() => {
        if (location.pathname.indexOf('MeshEditor') === -1) {
            if (meshEditorMicroApp?.unmount) {
                // meshEditorMicroApp.unmount();
                // setMeshEditorMicroApp({})
            }
        }

    }, [location]);

    const restoreRodinCardStatus = async (data) => {
        const STAGE_ENUM = {
            MODEL_GENERATE: 'ModelGenerate',
            MODEL_REFINE: 'ModelRefine',
            TEXTURE_GENERATE: 'TextureGenerate',
            TEXTURE_REFINE: 'TextureRefine',
        }

        const extractVersionNumber = (versionString) => {
            const match = versionString.match(/\d+/);
            return match ? parseInt(match[0], 10) : null;
        };

        const updateGenPipeline = (uuid, localGenPipeline, localRestoreData) => {
            setGenPipeline({
                ...localGenPipeline,
                hold: {
                    status: false,
                },
                taskInfo: {
                    ...localGenPipeline.taskInfo,
                    status: true,
                    data: uuid,
                    restore: {
                        status: true,
                        data: localRestoreData,
                    }
                }
            })
        }

        // Basic info
        let cardInfo = JSON.parse(JSON.stringify(data));
        let uuid = cardInfo.task_uuid
        let currentStage = cardInfo.step
        let localGenPipeline = JSON.parse(JSON.stringify(genPipeline))

        // Send request
        const convertedFiles = fetchAndConvertToFiles(cardInfo.rodin_generate_info.mesh_input_images, cardInfo.rodin_generate_info.material_input_images)
        setRodinUploadedImages(await convertedFiles);

        let localRestoreData = { viewOnly: (cardInfo.author.user_uuid !== localStorage.getItem('user_uuid')) || !localStorage.getItem('user_uuid') };
        // Current card info
        /*
            ModelGenerate and all stages depends on the following data and apply to all the status:
            1. SDF URL
            2. Geo Prompt
            3. Uploaded Images with corresponding URLs and names
            4. Redo Count
         */
        if (currentStage) {
            let settings = {}
            if (cardInfo.rodin_generate_info.mesh_generate_settings !== "FILE_NOT_FOUND") {
                settings = await fetchSettings({ settings: cardInfo.rodin_generate_info.mesh_generate_settings })
            } else {
                settings.prompt = cardInfo.prompt
                settings.view_weights = cardInfo.settings.view_weights
            }
            // Fetch Sym Status
            let currentVersion = cardInfo.settings.version
            let symStatus = []
            let direction = []
            let imageMode = false
            let initPrompt = ''
            if (!localRestoreData.viewOnly) {
                let history = {}
                history = await rodinHistory({ uuid: uuid, step: STAGE_ENUM.MODEL_GENERATE });
                cardInfo.history = JSON.parse(JSON.stringify(history.data))
                if (cardInfo.history) {
                    if (currentVersion && currentStage === STAGE_ENUM.MODEL_GENERATE) {
                        let settingsURL = cardInfo.history[currentVersion].settings
                        settings = await fetchSettings({ settings: settingsURL })
                        symStatus = settings.sym_dict
                        direction = settings.image_label
                    }
                    let settingsURL = cardInfo.history['v1'].settings
                    const newSettings = await fetchSettings({ settings: settingsURL })
                    imageMode = newSettings?.image_mode
                    initPrompt = newSettings?.prompt
                }
            } else {
                cardInfo.history = {}
            }

            localRestoreData = {
                ...localRestoreData,
                geometry: {
                    sdfUrl: cardInfo.model_preview_info.preview_sdf,
                    geoImages: cardInfo.rodin_generate_info.mesh_input_images,
                    geoPrompt: settings.prompt,
                    versionCounter: extractVersionNumber(cardInfo.settings.version),
                    version: cardInfo.settings.version,
                    viewWeights: settings.view_weights,
                    symStatus: symStatus,
                    direction: direction,
                    imageMode: imageMode,
                    initPrompt: initPrompt,
                    bbox_condition: settings?.bbox_condition,
                    bbox_condition_cfg: settings?.bbox_condition_cfg,
                    bbox_condition_weight: settings?.bbox_condition_weight,
                    voxel_condition: settings?.voxel_condition,
                    voxel_condition_cfg: settings?.voxel_condition_cfg,
                    voxel_condition_weight: settings?.voxel_condition_weight,
                    pcd_condition: settings?.pcd_condition,
                    pcd_condition_cfg: settings?.pcd_condition_cfg,
                    pcd_condition_weight: settings?.pcd_condition_weight,
                    pcd_condition_uncertainty: settings?.pcd_condition_uncertainty
                }
            }

            // Load SDF & Set Pipeline
            const localSDF = await fetchObjectToLocalURL(cardInfo.model_preview_info.preview_sdf)
            localGenPipeline = {
                ...localGenPipeline,
                geoPreviewLoading: {
                    status: true,
                    data: localSDF,
                    timestamp: Date.now()
                }
            }
        }
        /*
            ModelGenerate
            1. Model URL
         */
        if (currentStage === STAGE_ENUM.MODEL_REFINE || currentStage === STAGE_ENUM.TEXTURE_GENERATE || currentStage === STAGE_ENUM.TEXTURE_REFINE) {
            localGenPipeline = {
                ...localGenPipeline,
                geoConfirmed: {
                    ...localGenPipeline.geoConfirmed,
                    status: true,
                    data: cardInfo.prompt.split(".")[0] + "." //TODO: should use utils function to process
                },
                geoLoading: {
                    ...localGenPipeline.geoLoading,
                    status: true,
                    data: cardInfo.model_preview_info.model
                },
            }
        }

        if (currentStage === STAGE_ENUM.TEXTURE_GENERATE || currentStage === STAGE_ENUM.TEXTURE_REFINE) {
            let currentVersion = cardInfo.settings.version
            let currentRefImage = cardInfo.settings.reference_image
            let mtlImages;

            let historyStage = currentStage;
            if (historyStage === STAGE_ENUM.TEXTURE_REFINE) {
                historyStage = STAGE_ENUM.TEXTURE_GENERATE;
            }
            mtlImages = cardInfo.model_preview_info

            if (!localRestoreData.viewOnly) {
                let history = {}
                history = await rodinHistory({ uuid: uuid, step: historyStage });
                cardInfo.history = JSON.parse(JSON.stringify(history.data))
                if (!mtlImages.texture_pbr && cardInfo.history && currentRefImage && currentVersion) {
                    mtlImages = cardInfo.history[currentRefImage][currentVersion]
                }
            } else {
                cardInfo.history = {}
            }

            localRestoreData = {
                ...localRestoreData,
                material: {
                    refImage: currentRefImage,
                    version: currentVersion,
                    history: cardInfo.history,
                }
            }
            /*
                TextureRefine
                1. Load everything
             */
            if (currentStage === STAGE_ENUM.TEXTURE_REFINE) {
                localRestoreData = {
                    ...localRestoreData,
                    material: {
                        ...material,
                        settings: cardInfo.rodin_generate_info.material_generate_settings,
                        refImage: cardInfo.settings.reference_image,
                    }
                }

                localGenPipeline = {
                    ...localGenPipeline,
                    mtlConfirmed: {
                        ...localGenPipeline.mtlConfirmed,
                        status: true,
                    },
                    geoLoading: {
                        ...localGenPipeline.geoLoading,
                        status: true,
                        data: cardInfo.model_preview_info.model
                    },
                    mtlLoading: {
                        ...localGenPipeline.mtlLoading,
                        status: true,
                        data: mtlImages
                    }
                }

            } else {
                if (localRestoreData.viewOnly) {
                    // Load mtl after model loaded
                    localGenPipeline = {
                        ...localGenPipeline,
                        geoLoading: {
                            ...localGenPipeline.geoLoading,
                            status: true,
                            data: cardInfo.model_preview_info.model
                        },
                        // mtlLoading: {
                        //     ...localGenPipeline.mtlLoading,
                        //     status: true,
                        //     data: mtlImages
                        // }
                    }

                } else {
                    localGenPipeline = {
                        ...localGenPipeline,
                        geoLoading: {
                            ...localGenPipeline.geoLoading,
                            status: true,
                            data: cardInfo.model_preview_info.model
                        },
                        mtlLoading: {
                            ...localGenPipeline.mtlLoading,
                            status: true,
                            data: mtlImages
                        }
                    }
                }
            }
        }
        updateGenPipeline(uuid, localGenPipeline, localRestoreData)
    }

    const pushHistoryState = (taskUuid, taskType) => {
        const url = new URL(window.location.href)
        url.pathname = `/${taskType}/${taskUuid}`;
        window.history.pushState(null, null, url);
    }

    const handleClickCard = useCallback(async (task_uuid) => {
        if (!task_uuid) {
            console.error('task_uuid is not provided');
            return false;
        }

        const rep = await getTaskDetail(task_uuid);
        let taskType = rep?.data?.type
        if (taskType === 'API') {
            console.log("Task type API detected, fallback to Rodin", taskType)
            taskType = 'Rodin'
        }

        if (!taskType) {
            throw new Error(`Unable to get task detail: task type does not exist. (${rep?.data})`);
        }

        if (taskType === 'Rodin') {
            if (isRodinGenerating) {
                tip({
                    type: 'primary',
                    content: t('TIP_PRIMARY_APP_UPLOAD_PROGRESS'),
                });
                return false;
            }

            if (rep.data?.pending_jobs?.length) {
                tip({
                    type: 'warning',
                    content: t('TIP_WRAN_APP_MODEL_ENGAGED'),
                })
                return
            }
        }

        setPackInfo({
            details: rep.data,
            isPaid: null,
            isPackFinished: false
        })
        setTaskDetail(rep.data);
        setTaskInit(false);
        const modalObj = {
            type: taskType,
            taskuuid: task_uuid,
            state: true,
        }

        if (taskType === 'Rodin') {
            setGenPipeline(currentGenPipeline => {
                return {
                    ...currentGenPipeline,
                    hold: {
                        status: true
                    }
                }
            })
            restoreRodinCardStatus(rep.data) // await will cause delay in loading
        }
        const module = taskType === 'Rodin' ? 'rodin' : taskType === 'DreamFace' ? 'chatavatar' : 'imageto3d'
        // pushHistoryState(task_uuid, module)
        trackEvent(`${taskType} - Click Card`, false, task_uuid)
        setModalObj(modalObj);

        const truncatedPrompt = rep?.data?.prompt ? truncateWithEllipsis(rep.data.prompt, 32) : "";

        const cardMetaData = {
            image: rep?.data?.image_url,
            alt: rep?.data?.prompt,
            title: truncatedPrompt + (module === 'rodin' ? getSeoContent({ type: rodinBrandInfo }) : getSeoContent({ type: chatAvatarBrandInfo })),
            description: getSeoContent({ type: modelPagePresetDescription }),
            keywords: getSeoContent({ type: defaultRodinModelKeywords }),
            h1Text: rep?.data?.prompt,
            canonicalUrl: "https://hyper3d.ai/" + module + "/" + rep?.data?.task_uuid
        }

        setCurrentModelMetaData(cardMetaData)

        _czc.push(['_trackPageview', `/chatavatar/detail/${task_uuid}`, window.location.href]);
        _czc.push(['_trackEvent', 'Index', 'Card Click', 'Gallery Component']);

    }, [isRodinGenerating]);

    const handleOpenSub = useCallback(async (value) => {
        setShowSubscribe(value)
    }, [])

    const handleOpenLogin = useCallback(async (value) => {
        setShowLogin(value)
    }, [])

    const handleOpenFeedback = useCallback(async (value) => {
        try {
            setIsFeedbackModalOpen(value)
        } catch (e) {
            Sentry.captureException(e)
            console.error(e);
        }
    }, [])

    const handleOpenPre = useCallback(async (value) => {
        setOpenPre(value)
    }, [])


    const handleModalClose = () => {
        const close = () => {
            const uuid = genPipeline.taskInfo.data;
            resetGenPipeline(uuid, setGenPipeline)

            setPackInfo({
                details: {},
                isPaid: null,
                isPackFinished: false
            })
            setModalObj({
                ...modalObj,
                state: false,
                visited: false,
                RODIN_STATUS: {}
            })
            setTaskDetail(false)

            // reset meta data in header for seo
            setCurrentModelMetaData(false)
        }

        if (generate) {
            setGlobalTips({
                type: 'primary',
                content: t('TIP_PRIMARY_APP_BREWING'),
            });
        }
        // else if (modalObj.type === 'Rodin' && !genPipeline?.taskInfo?.restore?.data?.viewOnly) {
        //     tip({
        //         type: 'primary',
        //         content: t('TIP_PRIMARY_APP_MODEL_CLOSE'),
        //         yes: () => close(),
        //         no: (f) => f,
        //     });
        // } 
        else {
            close()
            if (isOpenImg3dGenerate && showRegenerate) {
                setIsOpenImg3dGenerate(false);
            }
            // window.history.pushState(null, '', '/')
        }
    };

    useEffect(() => {
        let overflowValue = 'overlay';
        if (showHistory || isOpenImg3dGenerate || showLogin || showCardsCon || iframe.type === 'Youtube' || modalObj.state || showStorageWrapper || isFeedbackModalOpen || showSubscribe || showReferral || showApiDashboard || isAnnotatorOpen?.status || !isFirstScreenShow) {
            overflowValue = 'hidden';
        }
        document.documentElement.style.overflowY = overflowValue;
    }, [showHistory, isOpenImg3dGenerate, showCardsCon, showLogin, modalObj, showStorageWrapper, isFeedbackModalOpen, showApiDashboard, showSubscribe, iframe.type, isAnnotatorOpen?.status, isFirstScreenShow]);

    useEffect(() => {
        if (!modalObj.state) {
            setMeshProfile(false);
            setGuessChatStatus('');
            setPosterGenerate(false);
            setChatImageURL(false);
            setShowProgress(false);
            setShowDownload(false);
            setCameraParams(false);
            setRegenePrivateSet(false);
        }

    }, [modalObj]);

    const handleOutsideClick = (e) => {
        if (feedbackModalRef.current && !feedbackModalRef.current.contains(e.target) && isFeedbackModalOpen) {
            setIsFeedbackModalOpen(false);
        }

        if (storageBoxRef.current && !storageBoxRef.current.contains(e.target) && showStorageWrapper) {
            setShowStorageWrapper(false);
        }
    };

    // 动态加载render, 减小包体积
    const setRodinRender = useSetRecoilState(rodinRenderAtom)
    const { data: RodinRender } = useRequest(() => {
        return import('@/rodinrender/app');
    })

    // Preload lazy loading component
    useEffect(() => {
        import('./components/ChatAvatar');
    }, []);

    useEffect(() => {
        if (RodinRender) {
            setRodinRender(RodinRender);
        }
    }, [RodinRender])

    // initialize language preference selection
    useEffect(() => {
        // get lang from URL
        const urlLang = searchParams.get('lang')
        // if URL has lang param, update localStorage & interfaceLang
        if (urlLang && urlLang in resources) {
            setInterfaceLang(urlLang)
            i18n.changeLanguage(urlLang)
            document.documentElement.setAttribute('lang', urlLang);
        } else {
            // if URL does not have lang param, then read localStorage
            const storedLang = localStorage.getItem('defaultI18n')
            if (storedLang) {
                setInterfaceLang(storedLang)
                i18n.changeLanguage(storedLang)
                document.documentElement.setAttribute('lang', storedLang);
                const url = new URL(window.location.href)
                url.searchParams.set('lang', storedLang)
                if (storedLang !== DEFAULT_LANG) {
                    url.searchParams.set('lang', storedLang)
                } else {
                    url.searchParams.delete('lang')
                }
                window.history.replaceState(null, '', url)
            } else {
                // document.documentElement.setAttribute('lang', DEFAULT_LANG);
                console.warn('[Language] No customized language preference detected, fallback to default.')
            }
        }
    }, [])

    useEffect(() => {
        let newSEOContent;
        if (currentModelMetaData) newSEOContent = currentModelMetaData
        else newSEOContent = getSeoContent({ path: location.pathname, lang: interfaceLang });
        setCurrentSEOContent(newSEOContent);
    }, [currentModelMetaData, location.pathname, interfaceLang]);

    useEffect(() => {
        if (['Rodin', 'ChatAvatar'].includes(currentNav)) {
            setOpenPre(false)
        }
    }, [currentNav])

    return (
        <>
            <SEOContent
                key={JSON.stringify(currentSEOContent)}
                title={currentSEOContent?.title}
                description={currentSEOContent?.description}
                keywords={currentSEOContent?.keywords}
                h1Text={currentSEOContent?.h1Text}
                image={currentSEOContent?.image}
                alt={currentSEOContent?.alt}
                canonicalUrl={currentSEOContent?.canonicalUrl}
            />
            {/*{!isPrerenderUserAgent() && (*/}
            {/*    <FirstScreenAnimation />*/}
            {/*)}*/}
            <CardClickContext.Provider value={useDebounce(handleClickCard, 300)}>
                <ModalClickContext.Provider value={handleModalClose}>
                    <ModalProvider>
                        <div
                            className="App"
                            onClick={handleOutsideClick}>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {showLogin ? <LoginPanel /> : ''}
                            </Sentry.ErrorBoundary>

                            {/* <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {isMobile ? <HeaderMobile /> : <Header />}
                            </Sentry.ErrorBoundary> */}

                            <div className='w-full h-[50px] sm:h-[0px] '></div>

                            {useRoutes(PCRouter)}

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <Restricted to="nav.index.view">
                                    {!isMobile && !location.pathname.includes('/MeshEditor') && isFirstScreenShow && <Nav />}
                                </Restricted>
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <MicroMeshEditorNode />
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <MicroNode handleOpenFeedback={useCallback(useDebounce(handleOpenFeedback, 300), [handleOpenFeedback])} useTips={useTips()} subscriptionsInfo={subscriptionsInfo} logInfo={logInfo} handleOpenLogin={useCallback(useDebounce(handleOpenLogin, 300), [handleOpenLogin])} handleOpenPre={useCallback(useDebounce(handleOpenPre, 300), [handleOpenPre])} handleOpenSub={useCallback(useDebounce(handleOpenSub, 300), [handleOpenSub])} handleCardClick={useCallback(useDebounce(handleClickCard, 300), [handleClickCard])} />
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {location.pathname.includes('/snap') ? null : <GlobalTips />}
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {modalObj.state && <Modal />}
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <Subscribe />
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {logInfo && <Referral />}
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <Restricted to="api.feature">
                                    {logInfo && <ApiDashboard />}
                                </Restricted>
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                {iframe.type && isAllowedTo('terms.view') && <Iframe iframe={iframe} />}
                            </Sentry.ErrorBoundary>

                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <Restricted to="feedback.view">
                                    <>
                                        {
                                            ['/imageto3d', '/chatavatar'].includes(location.pathname) && <>
                                                <FeedbackModal ref={feedbackModalRef} user={logInfo} />
                                                <StorageBox ref={storageBoxRef} />
                                            </>
                                        }
                                        {
                                            ['/rodin', '/', '/omnicraft', '/omnicraft/', '/omnicraft/hdri', '/omnicraft/formatcon', '/omnicraft/mesh', '/omnicraft/search', '/omnicraft/viewer'].includes(location.pathname) && <>
                                                <FeedbackModal ref={feedbackModalRef} user={logInfo} />
                                            </>
                                        }
                                    </>
                                </Restricted>
                            </Sentry.ErrorBoundary>
                            <Sentry.ErrorBoundary
                                fallback={({ error, resetError }) => (
                                    <ErrorPage
                                        errorMessage={error?.message}
                                        resetError={resetError}
                                    />
                                )}>
                                <Restricted to='featured.upgrade_modal'>
                                    <UpgradeModal
                                        visible={upgradeModal.visible}
                                        info={upgradeModal.info}
                                        onClose={handleClose}
                                        onConfirm={handleConfirmPlan}
                                        loading={loading}
                                    />
                                </Restricted>
                            </Sentry.ErrorBoundary>
                        </div >
                    </ModalProvider>
                </ModalClickContext.Provider >
            </CardClickContext.Provider >
        </>
    );
}

const MobileApp = () => {
    const location = useLocation();
    const iframe = useRecoilValue(iframeAtom)
    const [, setIsImgto3d] = useRecoilState(isImgto3dAtom);
    // const showLogin = useRecoilValue(showLoginAtom);

    useLayoutEffect(() => {
        setIsImgto3d(location.pathname.indexOf('/imageto3d') > -1)
        const themes = {
            light: ['/imageto3d', '/error', '/payment'],
            panorama: ['/panorama'],
        };
        let theme = 'dark';
        Object.entries(themes).forEach(([key, paths]) => {
            if (paths.some((path) => location.pathname.includes(path))) {
                theme = key;
            }
        });
        document.documentElement.dataset.theme = theme;
    }, [location]);

    return (
        <div className='mobileApp'>
            {useRoutes(MobileRouter)}
            {location.pathname.includes('/snap') ? null : <GlobalTips />}
            {iframe.type && <Iframe iframe={iframe} />}
        </div>
    )
}

const App = ({ isMobile }) => {
    const accessMap = {
        rodin_access: '/rodin',
        panorama_access: '/panorama',
        chatavatar_text_access: '/chatavatar',
        chatavatar_image_access: '/imageto3d',
    };
    const location = useLocation()
    const [, setIframe] = useRecoilState(iframeAtom)
    const navigate = useNavigate();
    const [logInfo, setLogInfo] = useRecoilState(logInfoAtom);
    const [userPermission, setUserPermission] = useRecoilState(userPermissionAtom);
    const [getUserId, , removeUserId] = useLocalStorage('user_uuid')
    const [getToken, , removeToken] = useLocalStorage('token')
    const [userId,] = useState(getUserId())
    const setGroupInfo = useSetRecoilState(groupInfoAtom);
    const setBalance = useSetRecoilState(balanceAtom);
    const [subscriptionsInfo, setSubscriptionsInfo] = useRecoilState(subscriptionsInfoAtom);
    const setSubscriptionsUnlimitInfo = useSetRecoilState(subscriptionsUnlimitInfoAtom)
    const setSubscriptionsEduState = useSetRecoilState(subscriptionsEduStateAtom)
    const setSubscriptionsPreInfo = useSetRecoilState(subscriptionsPreInfoAtom)
    const defaultLang = useRef(process.env.REACT_APP_DEFAULT_LANG)
    const roleOverwrite = useRef(window._env_.REACT_APP_ROLE)
    const subscriptionOverwrite = useRef(process.env.REACT_APP_DEFAULT_SUBSCRIPTION_PLAN)
    const currentNav = useRecoilValue(currentNavAtom);
    const Fallback = <ErrorPage />;
    const [aclRules, setAclRules] = useState([])
    const { t } = useTranslation();
    const tip = useTips();

    useEffect(() => {
        if (logInfo.user_uuid) {
            if (!localStorage.getItem('accepted_terms') || (localStorage.getItem('accepted_terms') !== null && localStorage.getItem('accepted_terms').split(',').filter(id => id === String(logInfo.user_uuid)).length === 0)) {
                setIframe({ type: 'Terms', src: '/Terms.html' })
            }
        }

        const setPermission = async (logInfo) => {
            const permissionInfo = await getPermission(roleOverwrite.current ? roleOverwrite.current : 'user', logInfo, subscriptionsInfo)
            setAclRules(permissionInfo)
        }

        setPermission(logInfo)

    }, [logInfo, subscriptionsInfo])

    useEffect(() => {
        sessionStorage.removeItem('selected_view_mode'); // Rodin View Mode
        // Set default lang
        if (defaultLang.current === "zh_CN") {
            i18n.changeLanguage("zh")
        } else if (defaultLang.current === "en_US") {
            i18n.changeLanguage("en")
        }

    }, [])

    useEffect(() => {
        const currentAccessKey = Object.entries(accessMap).find(
            ([accessUrl]) => location.pathname.startsWith(accessUrl),
        )?.[0];
        if (!currentAccessKey) return;
        if (!userPermission[currentAccessKey]) {
            navigate('/error');
        }
    }, [location, userPermission, navigate, accessMap]);

    useEffect(() => {
        const fetchData = async () => {
            if (userId && !logInfo) {
                await handleUserAndGroupInfo();
            } else {
                initNet()
            }
        };

        fetchData();
    }, [userId])

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "gtm.init_consent",
            'gtm.uniqueEventId': -1
        });

        setTimeout(() => {
            grantAllConsents();
        }, 2000);
    }, []);

    const handleLogout = async () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Logout Icon', 'User Panel']);
        localStorage.setItem('user_uuid', '');
        localStorage.setItem('privileged', '')
        localStorage.setItem('token', '');
        localStorage.setItem('group_uuid', '');
        await logout();
        window.location.href = location.pathname;
    };

    const handleUserAndGroupInfo = async () => {
        let userDataPromise, groupListPromise, settingsPromise, subscriptionDataPromise;
        const newPermission = { ...userPermission }

        setLogInfo({
            token: getToken(),
            avatar_url: '../../assets/defaultAvatar.png'
        });

        initNet(getToken());

        if (subscriptionOverwrite.current) {
            subscriptionDataPromise = undefined;
            groupListPromise = undefined;
            settingsPromise = undefined;
            const fakeSubscriptionData = {
                plan_level: subscriptionOverwrite.current,
            }
            setSubscriptionsInfo(fakeSubscriptionData)
            newPermission.subscribe = subscriptionOverwrite.current;
            newPermission.privateQuantity = Infinity;

            [userDataPromise] = await Promise.allSettled([
                getUserInfo({}),
                // getGroupList(),
                // getGroupSettings(),
            ]);
        } else {
            [userDataPromise, groupListPromise, settingsPromise, subscriptionDataPromise] = await Promise.allSettled([
                getUserInfo({}),
                getGroupList(),
                getGroupSettings(),
                getSubscriptionStatus()
            ]);
        }

        const userData = userDataPromise.status === 'fulfilled' ? userDataPromise.value : null;
        const groupList = groupListPromise?.status === 'fulfilled' ? groupListPromise.value : null;
        const settings = settingsPromise?.status === 'fulfilled' ? settingsPromise.value : null;
        const subscriptionData = subscriptionDataPromise?.status === 'fulfilled' ? subscriptionDataPromise?.value : null;
        if (userData?.data?.error === 'NO_SUCH_USER') {
            await handleLogout();
            return
        }

        if (!userData) {
            tip({
                type: 'error',
                content: 'Failed to get user data',
            });
            return
        }
        // TODO: storage user data at localstorage as fallback
        if (!userData) {
            tip({
                type: 'error',
                content: 'Failed to get user data',
            });
            return
        }

        const userDataMeta = userData.data.meta;
        const groupRes = groupList?.data?.groups
        localStorage.setItem('userInfo', JSON.stringify(userDataMeta))
        setLogInfo({
            ...userDataMeta,
            token: getToken()
        });
        setBalance(pre => {
            return {
                ...pre,
                selfBalance: userDataMeta?.balance
            }
        })
        newPermission.chatavatar_menu_Mine = true
        newPermission.chatavatar_menu_Recent = userDataMeta?.is_admin ? userDataMeta?.is_admin : false
        newPermission.privateQuantity = userDataMeta?.chances_left_to_set_private_task
        initNet(getToken());

        if (groupRes?.length) {
            const allowed_style = settings?.data?.settings?.style
            const allowed_topology = groupRes[0].settings?.allowed_topology
            const additional_process = groupRes[0].settings?.additional_process
            const additional_settings = groupRes[0].settings?.additional_settings
            allowed_topology?.length && (newPermission.chatavatar_allowed_topology = allowed_topology)
            additional_settings?.length && (newPermission.chatavatar_additional_settings = additional_settings)
            additional_process && (newPermission.chatavatar_allowed_additional_process = false)
            if (Reflect.ownKeys(allowed_style).length) {
                newPermission.chatavatar_allowed_style = allowed_style
            }

            newPermission.chatavatar_tab_group = true
            localStorage.setItem('group_uuid', groupRes[0].uuid)
            const groupInfo = await queryGroupInfo(groupRes[0].uuid)
            if (groupInfo.data.error) return Promise.reject(groupInfo.data.error);
            setGroupInfo(groupInfo.data)
            setBalance(pre => {
                return {
                    ...pre,
                    groupBalance: groupInfo.data.balance
                }
            })
        }
        if (subscriptionData?.data?.previous_subscriptions?.length) {
            let trialInfo;
            let trialEligibility = subscriptionData.data?.trial_eligibility
            if (trialEligibility) {
                trialInfo = subscriptionData.data?.previous_subscriptions
            } else {
                trialInfo = [
                    {
                        plan_level: 'Business',
                    },
                    {
                        plan_level: 'Creator',
                    }
                ];
            }
            setSubscriptionsPreInfo(trialInfo)
        }
        let subscriptionInfoRaw = null
        if (subscriptionData?.data?.active_subscriptions?.length) {
            let subsArr = subscriptionData.data.active_subscriptions

            subscriptionInfoRaw = subsArr.reverse().find(item => item.active);
            if (subscriptionInfoRaw) {
                setSubscriptionsInfo(subscriptionInfoRaw)
                newPermission.subscribe = subscriptionInfoRaw.plan_level
                newPermission.privateQuantity = Infinity
            }
        }
        const eduState = await getEduState()
        if (eduState?.data?.error) {
            setSubscriptionsEduState({
                isVerified: false,
                isExpired: false
            })
        }
        if (eduState && eduState?.data) {
            setSubscriptionsEduState({
                isVerified: eduState.data?.isVerified,
                isExpired: eduState.data?.isExpired
            })
        }
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        const totalSeconds = hours * 3600 + minutes * 60 + seconds;
        const currentTime = 24 * 60 * 60 - totalSeconds

        if (subscriptionData?.data) {
            const originalQuota = subscriptionData.data?.quota_unlimited_plan ? subscriptionData.data.quota_unlimited_plan : 0;
            const resetRemain = subscriptionData.data?.quota_reset_remain ? (subscriptionData.data.quota_reset_remain - currentTime) : 0;
            const resetRemainHours = subscriptionData.data?.quota_reset_remain / 3600;
            let finalQuota = originalQuota;

            if (resetRemainHours < 24) {
                // set fake decrease
                const date = new Date();
                date.setHours(0, 0, 0, 0);
                const rand = seededRandom(date.getTime());
                // random offset
                const offset = rand * 0.5 - 0.25;
                const elapsed = 12 - resetRemainHours;
                const adjustedElapsed = elapsed + offset;
                const increments = Math.max(0, Math.floor(adjustedElapsed / 2));
                finalQuota = Math.max(0, originalQuota - increments);
            }

            setSubscriptionsUnlimitInfo({
                quota: finalQuota,
                reset_remain: resetRemain,
            })
        }

        setUserPermission(newPermission)

        Sentry.setUser({ id: userDataMeta?.user_uuid, username: userDataMeta?.username, email: userDataMeta?.email });

        // umami.identify({ id: userDataMeta?.user_uuid, username: userDataMeta?.username, email: userDataMeta?.email, plan: subscriptionInfoRaw?.plan_level || 'None' });
        // umami.track(`Logged in: ${userDataMeta?.email}`)
        if (localStorage.getItem('unremember')) {
            removeToken();
            removeUserId();
            localStorage.removeItem('unremember');
            localStorage.removeItem('remember');
        }
    }

    const grantAllConsents = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'consent_update',
        });
    };

    return (
        <>
            <PermissionProvider permissions={aclRules} planLevel={subscriptionsInfo?.plan_level}>
                <Sentry.ErrorBoundary
                    fallback={Fallback}
                    showDialog={true}>
                    <Restricted to="workbench.view">
                        <DevPanel />
                    </Restricted>
                </Sentry.ErrorBoundary>

                {/*TODO: do not check with pathname directly*/}
                <Sentry.ErrorBoundary
                    fallback={Fallback}
                    showDialog={true}>
                    {isMobile && currentNav && (location.pathname.includes('/chatavatar') || location.pathname.includes('/imageto3d')) ? <MobileApp /> : <MainApp />}
                </Sentry.ErrorBoundary>

                <Sentry.ErrorBoundary
                    fallback={Fallback}
                    showDialog={true}>
                    <Restricted to="consent.view">
                        {!isPrerenderUserAgent() && (
                            <CookieConsent
                                location="bottom"
                                buttonText="Accept"
                                cookieName="user_consent"
                                style={{ background: "#2B373B", zIndex: "9999", opacity: "0.9" }}
                                buttonStyle={{ background: "#29232f", color: "#ffffff", fontSize: "13px" }}
                                expires={50}
                                onAccept={() => {
                                    grantAllConsents();
                                }}
                            >
                                {t('COOKIES_TITLE')}{" "}
                            </CookieConsent>
                        )}
                    </Restricted>
                </Sentry.ErrorBoundary>
            </PermissionProvider>
        </>
    )
}

export default App;